module.exports = __webpack_public_path__ + "img/1.789df197.jpg";